<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Sitios de Interés</h1>
        </div>
      </v-img>
    </v-card>
    <div class="gralMargenes" id="gralEspaciado">
      <hr>
      <br /><br />
      <a href="http://www.ujed.mx" target="_blank">UJED. Universidad Ju&aacute;rez del Estado de Durango</a><br />
      Conoce el sitio de nuestra máxima casa de estudio.<br /><br />
      <br /><br />
      <a @click="irPosgrado()" href="" target="_blank">DEP. Divisi&oacute;n de Estudios de Posgrado de FAZ</a>.<br />
      División de Estudios de Posgrado perteneciente a la Facultad de
      Agricultura y Zootecnia.<br />
      <br />
      <br /><br />
      <a href="http://www.agrofaz.net/" target="_blank">AGROFAZ</a><br />
      Revista de publicaci&oacute;n cient&iacute;fica de la Facultad de
      Agricultura y Zootecnia.<br />
      <br />
      <br /><br />
      <a href="https://sci-platform.org/sia/" target="_blank">SIA. SEMANA INTERNACIONAL DE AGRONOM&Iacute;A</a><br />
      Evento que año con año organiza nuestra Facultad, y en el cual se exponen
      los trabajos científicos generados tanto al interior de nuestra
      Universidad como de Centros de Investigación e Instituciones de Educación
      Superior en la Comarca Lagunera y en el país.<br />
      <br />
    </div>
  </v-app>
</template>
<script>

export default {
  data: () => ({
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Vinculación',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Bolsa de Trabajo',
        disabled: true,
        ruta: '/',
      },
    ],
  }),
  //METODOS UTILIZADOS
  methods: {
    //Ir a la pagina de posgrados FAZ
    irPosgrado() {
      location.replace(window.location.protocol + "//" + window.location.host + "/Posgrado/");

    },
  },
};
</script>